import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Auth } from '../../../core/services/auth';

@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './navbar.html',
  styleUrl: './navbar.css'
})
export class Navbar implements OnInit {
  @Input() pageTitle: string = '';
  @Input() pageSubtitle: string = '';
  @Input() searchPlaceholder: string | null = null;

  searchQuery: string = '';

  userName: string = '';
  userInitials: string = '';

  isProfileMenuOpen: boolean = false;

  constructor(private authService: Auth) {}

  ngOnInit() {
    const user = this.authService.getUser();
    if (user) {
      this.userName = user.fullName || 'User';
      this.userInitials = this.getInitials(user.fullName);
    }
  }

  toggleProfileMenu() {
    this.isProfileMenuOpen = !this.isProfileMenuOpen;
  }

  logout() {
    this.isProfileMenuOpen = false;
    this.authService.logout();
  }

  private getInitials(fullName: string): string {
    if (!fullName) return 'U';
    const parts = fullName.trim().split(' ');
    const first = parts[0]?.[0] || '';
    const last = parts.length > 1 ? parts[parts.length - 1][0] : '';
    return (first + last).toUpperCase();
  }
}